import { Dialog as MuiDialog, styled } from "@mui/material";
import React from "react";
const classes = { root: "dialog-root" };
const StyledMuiDialog = styled(MuiDialog)(() => ({
    [`&.${classes.root}`]: {
        "& .MuiDialog-container": {
            "& .MuiPaper-root": {
                borderRadius: "6px"
            }
        }
    }
}));
export const Dialog = (props) => {
    return React.createElement(StyledMuiDialog, { ...props, fullWidth: true, maxWidth: props.size, classes: { root: classes.root } });
};
